export default __webpack_public_path__ + "static/1609-433dd0bf423f80a7f710f261c164f16d.gif";